/* Science accordion. The source lets several panels sit open at once and starts
   with the first one open, so this mirrors that rather than forcing one. */
window.lvSciInit = function (rootId) {
  var root = document.getElementById(rootId);
  if (!root || root.dataset.lvInit) return;
  root.dataset.lvInit = '1';

  root.addEventListener('click', function (e) {
    var head = e.target.closest('.lvp-step__head');
    if (!head) return;
    var step = head.closest('.lvp-step');
    var open = step.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
};
